import directus from "api/services/directus";
import { DirectusFAQs, FilterableByCountry } from "custom-types/Directus";
import logger from "lib/logger";
import {
  constructFinderFaqSlug,
  filterByCountry,
} from "utils/finder/directusRequestUtils";

const getCitiesFaq = async (
  path: string,
  isDraft: boolean,
  filter?: string | string[],
  countryCode = "US"
) => {
  const defaultCountryCode = "US";
  try {
    const params = {
      fields: "*, location.country",
      "filter[location][country][_in]": [
        countryCode.toUpperCase(),
        defaultCountryCode,
      ],
      "filter[slug][_eq]": constructFinderFaqSlug(path, filter),
    };

    const result = await directus.get<DirectusFAQs[] & FilterableByCountry[]>(
      "faq",
      { params }
    );

    const data = filterByCountry<DirectusFAQs & FilterableByCountry>(
      result.data,
      countryCode
    ).find(
      // @ts-ignore (fix me please, do not replicate)
      (datum) => datum.status === (isDraft === true ? "draft" : "published")
    );

    return { data: data || { faqs: [] } };
  } catch (error) {
    logger.error(error);
    return { data: { faqs: [] } };
  }
};

export default getCitiesFaq;
